import React, { PureComponent } from 'react';
import { string, shape, bool } from 'prop-types';
import { Form } from 'semantic-ui-react';
import MaskedInput from 'react-text-mask';
import { getIn } from 'formik';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import styles from './CurrencyInput.less';

const numberMask = createNumberMask({
  prefix: '',
  allowDecimal: true,
  includeThousandsSeparator: true,
  decimalLimit: 10,
  integerLimit: 8,
});

class CurrencyInputField extends PureComponent {
  static propTypes = {
    guide: bool,
    label: string,
    disabled: bool,
    separator: string,
    placeholder: string,
    currencyCode: string,
    excludeSeparator: bool,
    form: shape({}).isRequired,
    field: shape({}).isRequired,
  }

  static defaultProps = {
    label: '',
    guide: false,
    separator: ',',
    disabled: false,
    placeholder: '',
    currencyCode: '',
    excludeSeparator: false,
  }

  handleChange = (e) => {
    const {
      separator,
      excludeSeparator,
      form: { setFieldValue },
      field: { name },
    } = this.props;
    const regex = new RegExp(`\\b${separator}\\b`, 'g');
    const value = excludeSeparator && e.target.value ? e.target.value.replace(regex, '') : e.target.value;
    if (value) {
      setFieldValue(name, +value);
    } else setFieldValue(name, value);
  }

  handleBlur = () => {
    const { field: { name }, form: { setFieldTouched } } = this.props;
    setFieldTouched(name);
  }

  render() {
    const {
      field: { name, value },
      form: { touched, errors },
      ...props
    } = this.props;

    const touch = getIn(touched, name);
    const error = getIn(errors, name);

    return (
      <Form.Field>
        <label htmlFor={name} className={styles.label}>{props.label}</label>
        <div className={styles.inputCurrency}>
          <MaskedInput
            id={name}
            value={value}
            showMask={false}
            mask={numberMask}
            guide={props.guide}
            onBlur={this.handleBlur}
            disabled={props.disabled}
            onChange={this.handleChange}
            placeholder={props.placeholder}
          />
          <span className={styles.currencyCode}>{props.currencyCode || null}</span>
        </div>
        {
          touch
          && error
          && <div className={styles.error}>{error}</div>
        }
      </Form.Field>
    );
  }
}

export default CurrencyInputField;
